// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import css from './notFound.css'
import { i18n } from '../index'
import { withRouter } from 'react-router-dom'
import get from 'lodash/get'
import Header from '../header/Header'
import Container from '../../common/container/Container'

type NotFoundProps = {
  location: any
}

const NotFound = (props: NotFoundProps) => {
  return (
    <div className={css.component}>
      <Header title={i18n.t('notFound.header')} />
      <Container>
        <h1>{i18n.t('notFound.title')}</h1>
        <p>
          {i18n.t('notFound.description', {
            pathname: get(props, 'location.pathname'),
          })}
        </p>
      </Container>
    </div>
  )
}

export default withRouter(NotFound)
